import React from 'react';
import './Header.scss';

export interface UnlinkedHeaderProps {
    title: JSX.Element | React.ReactNode | string;
    icon?: JSX.Element | React.ReactNode;
}

export const UnlinkedHeaderTitle: React.FunctionComponent<
    UnlinkedHeaderProps
> = (props) => {
    return (
        <h2 className="eds-text-hs header__text">
            {props.title}
            {props.icon}
        </h2>
    );
};
